<template>
  <div>
    <el-descriptions :column="3">
      <el-descriptions-item label="供应商">{{ trainsInfo.merchantName }}</el-descriptions-item>
      <el-descriptions-item label="供应商电话">{{
        trainsInfo.merchantPhoneNumber
      }}</el-descriptions-item>
      <el-descriptions-item label="车型">{{ trainsInfo.carType }}</el-descriptions-item>
      <el-descriptions-item label="班次时间">{{ trainsInfo.flightPlanTime }}</el-descriptions-item>
      <el-descriptions-item label="司机信息"
        >{{ trainsInfo.driverName }}{{ trainsInfo.driverMobilePhone }}</el-descriptions-item
      >
      <el-descriptions-item label="车牌信息">
        <yd-link
          permi="vehicle_view"
          :value="trainsInfo.plateNumber"
          type="vehicleDetail"
          :query="{ id: trainsInfo.carId }"
        />
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script >
const __sfc_main = {};
__sfc_main.props = {
  trainsInfo: {
    type: Object,
    default: () => {}
  }
};
export default __sfc_main;
</script>

<style lang="scss" scoped></style>
